module.exports = __webpack_public_path__ + "media/entities/1613-ec7c69f0.png";